// Pure functies voor Ja/Nee bij een vaste vraag (v19-R1 R6): Ja/Nee wist nooit getypte tekst.
const KOP = /^(Ja|Nee)(\s+—\s+|$)/;

export const zetJaNee = (tekst, k) => {
  const t = tekst || "";
  if (!t.trim() || t === "Ja" || t === "Nee") return k;
  const rest = t.replace(KOP, "");
  return `${k} — ${rest}`;
};

export const isJaNee = (tekst, k) => tekst === k || (tekst || "").startsWith(`${k} — `);
